import { gql } from "@apollo/client";

export const CREATE_DEVICE = gql`
  mutation CreateDevice($input: devices_insert_input!) {
    insert_devices_one(
        object: $input
    ) {
      id
    }
  }
`;

export const UPDATE_DEVICE = gql`
  mutation UpdateDevice($input: devices_set_input, $where: devices_bool_exp!) {
    update_items(_set: $input, where: $where) {
      id
    }
  }
`;

export const UPDATE_DEVICE_BY_PK = gql`
  mutation updateDeviceByPk($id: Int!, $input: devices_set_input!) {
    update_devices_by_pk(pk_columns: { id: $id }, _set: $input) {
      id
    }
  }
`;

export const ASSIGN_DEVICES_TO_EVENT = gql`
  mutation assignDevicesToEvent($ids: [Int!]!, $eventId: Int!) {
    update_devices(
      where: { id: { _in: $ids } }
      _set: { assigned_event_id: $eventId }
    ) {
      affected_rows
    }
  }
`;

export const UNASSIGN_DEVICE = gql`
  mutation unassignDevice($id: Int!) {
    update_devices_by_pk(
      pk_columns: { id: $id }
      _set: { assigned_event_id: null }
    ) {
      id
    }
  }
`;
